import { MASTER_PRODUCTS } from 'constants/merchandising';

const GIFT_MESSAGE_DENYLIST = {
  [MASTER_PRODUCTS.MENS_ZEFFER_STRAPS]: true,
  [MASTER_PRODUCTS.WOMENS_ZEFFER_STRAPS]: true,
  [MASTER_PRODUCTS.RUNNER_LACE_KIT]: true,
  [MASTER_PRODUCTS.DIGITAL_GIFT_CARD]: true,
  [MASTER_PRODUCTS.BIRD_MASK]: true,
};

const UNISIZE_PRODS = {
  [MASTER_PRODUCTS.RUNNER_LACE_KIT]: true,
  [MASTER_PRODUCTS.SADIE_SHAVES_THE_DAY]: true,
  [MASTER_PRODUCTS.BIRD_MASK]: true,
};

export { GIFT_MESSAGE_DENYLIST, UNISIZE_PRODS };
